import React, { createContext, useContext, ReactNode } from 'react';
import { LocationFilter } from '../config/eventsConfig';

interface LocationContextType {
  currentLocation: LocationFilter;
}

const LocationContext = createContext<LocationContextType>({
  currentLocation: 'all',
});

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
};

interface LocationProviderProps {
  children: ReactNode;
  location: LocationFilter;
}

export const LocationProvider: React.FC<LocationProviderProps> = ({ children, location }) => {
  const value = {
    currentLocation: location,
  };

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};